<div *ngIf="RoleId=='1'" class="col-md-6">
  <div class="panel with-nav-tabs panel-default ">
    <div class="panel-heading">
      <ul class="nav nav-tabs ">
        <li [class.active]="tabSelected === 'users'" id="home" (click)="onSelect('users')">
          <a data-toggle="tab"><b style="font-size:18px;" class="">Users</b></a>
        </li>
        <li [class.active]="tabSelected === 'sectors'" (click)="onSelect('sectors')">
          <a data-toggle="tab"><b style="font-size:18px;">Sectors</b></a>
        </li>
        <li [class.active]="tabSelected === 'models'" (click)="onSelect('models')">
          <a data-toggle="tab"><b style="font-size:18px;">Models</b></a>
        </li>
        <li [class.active]="tabSelected === 'labels'" (click)="onSelect('labels')">
          <a data-toggle="tab"><b style="font-size:18px;">Labels</b></a>
        </li>
        <li [class.active]="tabSelected === 'backup'" (click)="onSelect('backup')">
          <a data-toggle="tab"><b style="font-size:18px;">Backup/Status</b></a>
        </li>
        <li [class.active]="tabSelected === 'log'" (click)="onSelect('log')">
          <a data-toggle="tab"><b style="font-size:18px;">Log</b></a>
        </li>
      </ul>
    </div>
    <div class="panel-body" style="height:auto!important;">
      <div class="tab-content" style="padding-left:15px;">

        <app-users *ngIf="tabSelected === 'users'"></app-users>
        <app-sectors *ngIf="tabSelected === 'sectors'"></app-sectors>
        <app-models *ngIf="tabSelected === 'models'"></app-models>
        <app-labels *ngIf="tabSelected === 'labels'"></app-labels>
        <app-backup *ngIf="tabSelected === 'backup'"></app-backup>
        <app-log *ngIf="tabSelected === 'log'"></app-log>
      </div>
    </div>
  </div>
</div>